import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  resources: {
    en: {
      translations: require('./locales/en/transaction.json')
    },
    arab: {
      translations: require('./locales/arab/transaction.json')
    }
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['en', 'arab'];

export default i18n;



// import i18n from "i18next";
// import { initReactI18next } from "react-i18next";
// import LanguageDetector from "i18next-browser-languagedetector";
 
// import { TRANSLATIONS_ARAB } from "./locales/arab/transaction";
// import { TRANSLATIONS_EN } from "./locales/en/transaction";
 
// i18n
//  .use(LanguageDetector)
//  .use(initReactI18next)
//  .init({
//    resources: {
//      en: {
//        translation: TRANSLATIONS_EN
//      },
//      zh: {
//        translation: TRANSLATIONS_ARAB
//      }
//    }
//  });
 
// i18n.changeLanguage("ARAB");